module.exports = __webpack_public_path__ + "assets/img/小文诊股.8cfe52d2.png";